import axios from "axios";
import axiosClient from "./axiosClient";
import { REGISTRATION_API_URL } from "../config/apiConfig";
// import {useSelector} from "react-redux";

export const loginApi = (email, password, tenantCode, countryCode) => {

    return axiosClient.post(
        "/auth/login",
        {
            email,
            password
        },
        {
            headers: {
                "Content-Type": "application/json",
                "X-Tenant-Code": tenantCode,
                "X-Tenant-Country": countryCode
            },
            withCredentials: true
        }
    );
};

export const googleLoginApi = (token, tenantCode, countryCode) => {
    return axiosClient.post(
        "/auth/googleWithVerification",
        {
            token
        },
        {
            headers: {
                "Content-Type": "application/json",
                "X-Tenant-Code": tenantCode,
                "X-Tenant-Country": countryCode
            },
            withCredentials: true
        }
    );
};

/**
 * Remplace le mot de passe de l'utilisateur connecté (Bearer posé par axiosClient).
 * Réponse : { token, passwordChangeRequired: false }. Refus : 400 { error: "INVALID_CURRENT_PASSWORD" | "PASSWORD_TOO_SHORT" | … }.
 */
export const changePasswordApi = (currentPassword, newPassword) => {
    return axiosClient.post("/auth/change-password", { currentPassword, newPassword });
};

/**
 * Choisit le mot de passe avec le lien reçu par email (public : tenant et pays du lien en en-têtes).
 * Réponse : { token, passwordChangeRequired: false } ; refus : 400 { error: "INVALID_OR_EXPIRED_LINK" | "PASSWORD_…" }.
 */
export const setPasswordApi = (token, newPassword, tenantCode, countryCode) => {
    return axiosClient.post(
        "/auth/set-password",
        { token, newPassword },
        { headers: { "X-Tenant-Code": tenantCode, "X-Tenant-Country": countryCode } }
    );
};

/** Nouveau lien « choisir mon mot de passe » (lien expiré, oubli) : toujours 202, que le compte existe ou non. */
export const requestPasswordSetupApi = (email, tenantCode, countryCode) => {
    return axios.post(`${REGISTRATION_API_URL}/password-setup/requests`, {
        email: email.trim(),
        tenantCode,
        country: countryCode,
        application: "AGRO"
    });
};
